export interface EventPayload {
  event: string;
  eventCategory: string;
  eventAction: string;
  eventLabel: string;
  eventValue?: string | number;
}

export interface MessageParams {
  type: string;

  [key: string]: any;
}

const sendMessage = (iframeId: string) => ({ type, ...params }: MessageParams): void => {
  const payload = {
    type,
    iframeId,
    ...params,
  };

  window.parent.postMessage(
    {
      source: 'special-offers',
      payload,
    },
    '*',
  );
};

export const generateSendMessageToParentWindow = (iframeId) => sendMessage(iframeId);
